import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	palette: {
		primary: {
			main: "#78c4dc",
			contrastText: "#ffffff",
		},
	},
	typography: {
		h6: {
			fontSize: "1rem", // ~16px
		},
		body1: {
			color: "#1a262a",
		},
		body2: {
			color: "#1a262a",
		},
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: `
                html {
                    font-size: 1rem; /* Default font size for large devices */
                }
                @media (max-width: 1366px) {
                    html {
                        font-size: 0.8rem; /* Medium devices */
                    }
                }
            `,
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					fontSize: "1rem", // Adjust the tooltip font size
					padding: "10px 15px", // Optional: Adjust padding for better spacing
				},
			},
		},
	},
});

export default theme;
